module.exports = "pegasus_template/assets/x_white.png";